import React from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'

const CartBtn = () => {
    // We get a state of addItems
    // Write the name of the file not the function
    const state = useSelector((state) => state.addItem)
    return (
        <>
            <div className="buttons">
                <NavLink to="/cart" className="btn btn-outline-dark ms-2 bg-white">
                    <i class="fa-solid fa-cart-shopping me-1"></i>Cart ({state.length})
                </NavLink>
            </div>
        </>
    )
}

export default CartBtn
